import api from './api'

const transactionService = {
  async getAll(params = {}) {
    const response = await api.get('/transactions', { params })
    return response.data
  },

  async getById(id) {
    const response = await api.get(`/transactions/${id}`)
    return response.data
  },

  async getStats() {
    const response = await api.get('/transactions/stats')
    return response.data
  },

  async rerunEmail(emailId) {
    const response = await api.post(`/gmail/rerun/${emailId}`)
    return response.data
  },

  async rerunTransaction(transactionId) {
    // Rerun can take a while (Docling + OpenAI + SOS). Use a longer timeout and
    // suppress the global "backend restarting" banner on client-side timeout.
    const response = await api.post(
      `/transactions/${transactionId}/rerun`,
      {},
      { timeout: 180000, suppressBackendDownOnTimeout: true }
    )
    return response.data
  },

  async clearHistory() {
    const response = await api.delete('/transactions/clear', {
      data: { confirm: 'delete' }
    })
    return response.data
  }
}

export default transactionService
